import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendCompanyTestResultField,
	FrontendUserInfo,
	SysAdminCompanyTestingWorkflowWithBatchTypeIds,
} from "node-library/dist/portal";

import { Card } from "@mui/material";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { SystemRole } from "node-library/dist/constants";
import { FrontendCompanyWorkflow } from "node-library/dist/structures/frontendTestWorkflowStructureDefinitions";

interface Props {
	workflow: SysAdminCompanyTestingWorkflowWithBatchTypeIds;
	batchTypes: Array<string>;
	goToViewWorkflowDetails: () => void;
}

export default function WorkflowCell(props: Props) {
	const { t: translation } = useTranslation();

	const { goToViewWorkflowDetails, workflow, batchTypes } = props;

	let actionOptions: Array<{
		key: string;
		onClick: () => void;
		children: React.ReactNode;
	}>;

	const userHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "5px",
			}}
		>
			{/* <KebabDropdownButton
				menuOptions={actionOptions}
				id={`batch-more-action-menu-${order.orderBarcodeId}`}
				onClick={(e) => {}}
			></KebabDropdownButton> */}
		</div>
	);
	const userBody: React.ReactNode = (
		<div
			style={{
				marginTop: "10px",
				display: "flex",
				flexDirection: "column",
				gap: "5px",
			}}
		>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">{translation("Name")}</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{workflow.workflowName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">{translation("Type")}</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{workflow.workflowType}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("BatchTypes")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{batchTypes.length > 0 ? batchTypes.join(", ") : translation("None")}
				</div>
			</div>
		</div>
	);

	return (
		<Card
			className="card-border-radius-14p card-medium-padding highlight-card"
			style={{ cursor: "pointer" }}
			key={workflow.workflowId}
			onClick={() => {
				goToViewWorkflowDetails();
			}}
		>
			{userHeaderRow}
			{userBody}
		</Card>
	);
}
